<template>
  <div>
    <div class="header-box" v-if="isH5">
      <PageMbHeader
        :title="title"
        :transShow="false"
        :transOpen="false"
        :iconShow="!isNewTab"
        @icon-click="back"
      />
    </div>
    <div class="feedback-content">
      <CancelOrderContent class="feedback-unsubmit-content">
        <template v-slot:left>
          <div class="img-content">
            <img :src="statusImg" v-img-error alt="" class="img" />
          </div>
        </template>
        <template v-slot:right>
          <div class="right-cont">
            <div class="info-content">
              <div class="tit">{{ title }}</div>
              <div
                class="desc"
                v-for="(item, index) in desc"
                :key="'desc' + index"
              >
                {{ item }}
              </div>
            </div>
            <Contact
              class="concact-cont"
              :showText="customerServiceContactText"
              :desc="customerServicePhone"
              :trackInfo="trackServiceContactInfo"
              @click.native="contactClick"
            >
              <span slot="showIcon">
                <i class="icon-outline_phone"></i>
              </span>
              <span slot="descIcon">
                <i class="icon-outline_phone"></i>
              </span>
            </Contact>
          </div>
        </template>
      </CancelOrderContent>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getCustomerServicePhone } from '@/utils/getCountyConfig';
import statusImg from '@/assets/images/order/cancel/customer_service.png';
import Contact from '@/components/Contact';
import CancelOrderContent from '@/components/CancelOrderContent';
import PageMbHeader from '@/components/PageMbHeader';
import { get } from 'lodash-es';
import { getIsNewTab } from '@/utils/tools';

const csTelNumber = getCustomerServicePhone();

export default {
  name: 'feedbackUnSubmit', // 少餐错餐
  components: {
    Contact,
    CancelOrderContent,
    PageMbHeader,
  },
  props: {
    reason: {
      type: String,
      default() {
        return '';
      },
    },
    uid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      customerServicePhone: csTelNumber,
      customerServiceContactText: this.$t(
        'FoodC_web_Customer_Service_EBqf' /*客服*/
      ),
      statusImg: statusImg,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    title() {
      const title = {
        overtime: this.$t('反馈超时'),
        unfinished: this.$t('订单尚未完成'),
      };
      return title[this.reason];
    },
    desc() {
      const desc = {
        overtime: [
          this.$t(
            '您的订单完成已经超过24小时，无法自助申请，如您有问题可联系客服，给您带来不便深表歉意。'
          ),
        ],
        unfinished: [
          this.$t('您的订单还未完成，您可以联系骑手确认当前的具体配送位置。'),
        ],
      };
      return desc[this.reason];
    },
    trackServiceContactInfo() {
      return {
        eventId: 'sailing_c_x_problem_apply_timeout_service_sw',
        eventLabel: '问题申请提交反馈超时页面--联系客服曝光',
        attrs: {
          order_id: get(this, '$route.query.orderId', ''),
        },
      };
    },
    isNewTab() {
      return getIsNewTab();
    },
  },
  methods: {
    contactClick() {
      const orderId = get(this, '$route.query.orderId', '');
      this.$trackEvent({
        eventId: 'sailing_c_x_problem_apply_timeout_phone_ck',
        eventLabel: '问题申请提交反馈超时页面--点击联系客服',
        attrs: {
          order_id: orderId,
        },
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    const orderId = get(this, '$route.query.orderId', '');
    this.$trackEvent({
      eventId: 'sailing_c_x_problem_apply_timeout_sw',
      eventLabel: '问题申请提交反馈超时页面曝光',
      attrs: {
        order_id: orderId,
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.feedback-content {
  height: calc(100vh - 180px);
  overflow-y: auto;
  background: #fff;
  max-width: 940px;
  margin: 0 auto;
  border-radius: 8px;
  .img-content {
    width: 250px;
    height: auto;
    margin: 80px auto 0;
    .img {
      width: 100%;
      height: 100%;
    }
  }

  .info-content {
    position: relative;
    overflow-y: auto;
    .tit {
      margin: 34px 0 20px;
      font-family: 'Aspira Medium';
      font-size: 24px;
      line-height: 28px;
      color: #000000;
    }
    .desc {
      font-family: 'Aspira Light';
      font-size: 14px;
      line-height: 18px;
      color: #000000;
    }
    .tit,
    .desc {
      max-width: 500px;
      margin: 0 auto 20px;
    }
  }
  .concact-cont {
    margin-bottom: 24px;
  }
  .cancel-order-content {
    border-radius: 8px;
  }
}
</style>

<style lang="scss" scoped>
// 移动端适配
@media screen and (max-width: 768px) {
  .header-box {
    position: sticky;
    top: 0;
    z-index: 9;
  }
  .cate-header-wrapper {
    position: relative;
  }
  .feedback-unsubmit-content.cancel-order-content {
    background: #f5f5f7;
  }
  .feedback-content {
    background: #f5f5f7;
    height: auto;
    padding: 0 rem(24);
    .img-content {
      width: 100%;
      height: 100%;
      margin-top: 0;
      margin-left: 0;
      padding: rem(48) rem(160) rem(0);
    }
    .img {
      width: 100%;
      height: 100%;
    }
    .right-cont {
      min-height: 0;
    }

    .info-content {
      position: relative;
      .tit {
        margin-top: rem(40);
        margin-bottom: rem(24);
        font-family: 'Aspira Medium';
        font-size: rem(44);
        line-height: rem(52);
        color: #000000;
        text-align: left;
      }
      .desc {
        font-family: 'Aspira Light';
        font-size: rem(28);
        line-height: rem(34);
        color: #000000;
        margin-bottom: rem(24);
        color: #999999;
        text-align: left;
      }
    }
    .concact-cont {
      margin-bottom: rem(24);
      text-align: left;
    }
    .tit {
      margin: rem(40) 0 rem(24);
      font-family: 'Aspira Medium';
      font-size: rem(44);
      line-height: rem(52);
      color: #000000;
    }
    .desc {
      font-family: 'Aspira Light';
      font-size: rem(28);
      line-height: rem(34);
      color: #000000;
    }
  }
}
</style>
